export enum PaymentTransactionType {
    Other = 0,
    Sale = 1,
    Refund = 2,
    Preauth = 4,
    CancelPreauth = 8
}
